exports = module.exports = require("./../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ribbon{background-color:rgba(170,0,0,.5);left:-3.5em;moz-transform:rotate(-45deg);ms-transform:rotate(-45deg);o-transform:rotate(-45deg);webkit-transform:rotate(-45deg);transform:rotate(-45deg);overflow:hidden;position:absolute;top:40px;white-space:nowrap;width:15em;z-index:9999;opacity:.75}.ribbon,.ribbon a{pointer-events:none}.ribbon a{color:#fff;display:block;font-weight:600;font-size:20px;margin:1px 0;padding:10px 50px;text-align:center;text-decoration:none;text-shadow:0 0 5px #444}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/main/webapp/app/layouts/profiles/page-ribbon.scss
// module id = 349
// module chunks = 0